import React from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";
import { motion } from "framer-motion";

import { ReactComponent as CheckIcon } from "../../assets/img/check-icon.svg";

const El = styled.button`
  color: #9a9a9a;
  font-family: sans-serif;
  font-size: ${rem(13)};
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  padding: 0;
  width: 100%;
  transition: font-size 0.3s, color 0.3s;
  line-height: ${rem(20)};
  height: ${rem(20)};
  margin-bottom: ${rem(8)};
  position: relative;
  padding-left: ${rem(30)};
  flex-shrink: 0;

  &:focus {
    outline: none;
  }

  ${({ open }) =>
    open &&
    css`
      font-size: ${rem(17)};
      color: #000;

      ${Number} {
        font-size: ${rem(14)};

        &::before {
          width: ${rem(24)};
          height: ${rem(24)};
          background: #fff;
          border: 1px solid;
        }
      }
    `}

  ${({ filled }) =>
    filled &&
    css`
      color: #000;
      cursor: pointer;

      ${Number} {
        color: transparent;

        &::before {
          background: #CC6F4C;
          border: 1px solid #CC6F4C;
        }

        svg {
          transform: translate(-50%, -50%) scale(1);
          opacity: 1;
          transition: transform 0.3s 0.3s, opacity 0.3s 0.3s;
        }
      }
    `}
`;

const Number = styled.div`
  width: ${rem(20)};
  height: ${rem(20)};
  font-size: ${rem(11)};
  font-weight: 700;
  margin-right: ${rem(10)};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  position: absolute;
  left: 0;
  top: 50%;
  top: 0;

  &:before {
    content: "";
    width: ${rem(20)};
    height: ${rem(20)};
    background: #eaeaea;
    border-radius: 999em;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: -1;
    transform: translate(-50%, -50%);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.75);
    opacity: 0;
    fill: #fff;
    width: ${rem(10)};
    height: ${rem(12)};
    transition: transform 0.3s 0s, opacity 0.3s 0s;
  }
`;

const Edit = styled(motion.span)`
  color: #2d71b6;
  display: inline-block;
  padding-left: ${rem(7)};
  margin-left: ${rem(7)};
  position: relative;
  font-size: ${rem(13)};

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    height: ${rem(10)};
    margin-top: ${rem(-5)};
    background: #000;
    opacity: 0.2;
    width: 1px;
  }
`;

const SectionHeading = ({ filled, open, index, setActiveSection, title }) => (
  <El
    filled={filled}
    onClick={() => {
      filled && setActiveSection(index);
    }}
    open={open}
  >
    <Number>
      {index + 1}
      <CheckIcon />
    </Number>
    {title}

    <Edit
      animate={filled ? { opacity: 1, x: 0 } : { opacity: 0, x: 10 }}
      transition={{ ease: "easeOut", duration: 0.3 }}
    >
      Edit
    </Edit>
  </El>
);

export default SectionHeading;
